<template>
  <BasePageContainer
    v-if="initialized"
    class="pt-6">
    <page-header
      has-back>
      予定編集
    </page-header>
    <event-form
      ref="form"
      :event="event"
      is-edit
      @submit="updateEvent" />
  </BasePageContainer>
</template>

<script>
import { format } from 'date-fns'
import PageHeader from '@/components/parts/PageHeader.vue'
import EventForm from '@/components/view/EventForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
export default {
  components: {
    PageHeader,
    EventForm
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      initialized: false,
      event: null,
    }
  },
  computed: {
    eventId() {
      return this.$route.params.id
    },
  },
  async created() {
    this.$store.commit('startLoading')
    this.event = await this.fetchEvent()
    this.initialized = true
    this.$store.commit('finishLoading')
  },
  methods: {
    fetchEvent() {
      return this.$axios.get(`/events/${this.eventId}/`).then(res => res.data)
    },
    async updateEvent(requestBody) {

      this.$store.commit('startLoading')

      await this.$axios.patch(`/events/${this.eventId}/`, requestBody).then((res) => {
        this.$store.commit('notify/set', {message: '予定を編集しました。'})
        const editedEventDate = new Date(res.data.startAt)
        const formattedDate = format(editedEventDate, 'yyyy-MM-dd')
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/events/?date=${formattedDate}`)
        })
      }).catch(err => {
        console.error(err)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
      this.$store.commit('finishLoading')
    },
  }
}
</script>

<style>

</style>